import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable, Subject} from "rxjs";
import {ItemManagerService} from "../itemManager/item-manager.service";
import {TimelineSliderComponent} from 'src/app/components_2.1/timeline-slider/timeline-slider.component'

@Injectable({
  providedIn: 'root'
})
export class TimelineService {

  public timeline_slider: TimelineSliderComponent
  public timelineVisible: boolean = false
  protected timeFrames: object[] = [];
  protected min: number = Infinity;
  protected max: number = 0;
  private _defaultTimeString = window['DEFAULT_TIMELINE_DATE'] && window['DEFAULT_TIMELINE_DATE'].trim().length > 0 ? window['DEFAULT_TIMELINE_DATE'] : null
  protected _activeFrames: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  get activeFrames(): Observable<string[]> {
    return this._activeFrames.asObservable();
  }
  public timelineTime: any = false

  public forceShowTimelineSlider() {
    if (this.timeline_slider) {
      this.timeline_slider.isSliderVisible = true
      this.timeline_slider.isListVisibility = true
    }
  }

  public forceHideTimelineSlider() {
    if (this.timeline_slider) {
      this.timeline_slider.isSliderVisible = false
      this.timeline_slider.isListVisibility = false
    }
  }

  private _onSelectedTimelineGranularityUpdated$: Subject<number> = new Subject<number>()
  get onSelectedTimelineGranularityUpdated$() {
    return this._onSelectedTimelineGranularityUpdated$.asObservable()
  }

  private _selectedTimelineGranularity = null
  get selectedTimelineGranularity() {
    return this._selectedTimelineGranularity
  }

  set selectedTimelineGranularity(val) {
    this._selectedTimelineGranularity = val
    this._onSelectedTimelineGranularityUpdated$.next(this._selectedTimelineGranularity)
  }

  get defaultTimeString() {
    return this._defaultTimeString
  }

  public isActive: boolean = false;

  constructor(
  ) {

    this.timeFrames = window['TIME_VOCABULARY_CONFIG'];
    console.log('timeframes', this.timeFrames);
    this.timeFrames.forEach(timeVocabulary => {
      if (timeVocabulary['datetime_start'] && timeVocabulary['datetime_end']){
        let s = new Date(timeVocabulary['datetime_start'].replace(' ', 'T'));
        let e = new Date(timeVocabulary['datetime_end'].replace(' ', 'T'));
        if (s.getTime() < this.min) {
          this.min = s.getTime();
        }
        if (e.getTime() > this.max) {
          this.max = e.getTime();
        }
      }
      this.registerTimelineOption(timeVocabulary['time_window_name']);
    });
    this.setTime(null);
  }

  protected _timelineOptions: BehaviorSubject<string[]> = new BehaviorSubject<string[]>([]);
  get timelineOptions(): Observable<string[]> {
    return this._timelineOptions.asObservable();
  }

  registerTimelineOption(option: string) {
    if (!option || option.length === 0) {
      return;
    }
    let data = this._timelineOptions.getValue();
    if (data.indexOf(option) === -1) {
      data.push(option);
      data.sort();
      this._timelineOptions.next(data);
    }
  }

  hasAvailableOptions(): boolean {
    return this.timeFrames.length > 0;
  }

  getMinDate() {
    return this.min;
  }

  getMaxDate() {
    return this.max;
  }

  setTimelineVisible(visibility: any) {
    this.timelineVisible = visibility
  }

  setTime(time) {
    if (time === null) {
      this._activeFrames.next([]);
      this.isActive = false;
    } else {
      this.isActive = true;
      let activeFrames = [];
      this.timeFrames.forEach(timeVocabulary => {
        if (timeVocabulary['datetime_start'] && timeVocabulary['datetime_end']){
          let s = new Date(timeVocabulary['datetime_start'].replace(' ', 'T'));
          let e = new Date(timeVocabulary['datetime_end'].replace(' ', 'T'));
          if (time >= s.getTime() && time <= e.getTime()) {
            activeFrames.push(timeVocabulary['time_window_name']);
          }
        }
      });
      this._activeFrames.next(activeFrames);
    }
    this.timelineTime = time;
  }

  isEnabled(): boolean {
    if (!window.hasOwnProperty('TIMELINE_ENABLED')) {
      return false;
    }
    return !!window['TIMELINE_ENABLED'];
  }
}
